import { isBrowser } from './check';
const USER_AGENT_FILTERS = {
  snapchat: {
    userAgents: ['Snapchat'],
    allowed: ['email'],
  },
};

function filterProvidersUsingUA(loginProviders) {
  if (!isBrowser()) return loginProviders;

  const ua = window.navigator.userAgent;
  const filters = Object.keys(USER_AGENT_FILTERS);
  let allowed = [];
  let found = false;
  for (let i = 0; i < filters.length && !found; i++) {
    const userAgentList = USER_AGENT_FILTERS[filters[i]].userAgents;
    for (let j = 0; j < userAgentList.length; j++) {
      if (ua.indexOf(userAgentList[j]) > -1) {
        found = true;
        allowed = USER_AGENT_FILTERS[filters[i]].allowed;
        break;
      }
    }
  }

  if (found) {
    return loginProviders.filter((login) => allowed.includes(login));
  }

  return loginProviders;
}

export { filterProvidersUsingUA };
